// Iter 123 — messages d'erreur auth localisés à partir du header `X-Error-Code` (backend),
// avec repli sur `detail` (chaîne ou tableau 422) puis message générique. Jamais de texte anglais en dur.

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return '';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : '')).filter(Boolean).join(' ');
  }
  if (typeof detail === 'object') return detail.message || detail.msg || '';
  return String(detail);
};

export const authErrorMessage = (error, t, fallbackKey = 'rApp.authErrors.generic') => {
  const response = error?.response;
  if (!response) return t('rApp.authErrors.network');
  const headers = response.headers || {};
  const code = headers['x-error-code'];
  if (code) {
    const key = `rApp.authErrors.${code}`;
    const translated = t(key);
    if (translated !== key) {
      const retry = parseInt(headers['retry-after'] || '0', 10);
      const minutes = Math.max(1, Math.ceil((Number.isFinite(retry) ? retry : 0) / 60));
      return translated.replace(/{{\s*minutes\s*}}/g, String(minutes));
    }
  }
  if (response.status === 422) return t('rApp.authErrors.validation');
  return formatApiErrorDetail(response.data?.detail) || t(fallbackKey);
};
